export const dripOfferAssets = {
	popupBackground: "/spec_drip_offer/background-popup.png",
	topBrush: "/spec_drip_offer/brush-v2.png",
	collectedNode: "/spec_drip_offer/collected-node.png",
	shine: "/spec_drip_offer/shine.png",
	tiki: "/spec_drip_offer/tiki.gif",
	title: "/spec_drip_offer/title-drip-offer.png",
	unclaimedNode: "/spec_drip_offer/unclaimed-node.png",
	emptyBox: "/spec_drip_offer/web_drip_offer_brown_box.png",
	boxWithX: "/spec_drip_offer/web_drip_offer_brown_box-x.png"
} as const;
